export function parseApiError(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  if (typeof error === 'object' && error !== null) {
    if ('data' in error) {
      if (typeof error.data === 'string') {
        return error.data;
      }

      if (typeof error.data === 'object' && error.data !== null) {
        if ('message' in error.data && typeof error.data.message === 'string') {
          return error.data.message;
        }

        if ('errors' in error.data && Array.isArray(error.data.errors)) {
          return error.data.errors.join(',\n');
        }
      }
    }
  }

  return 'Unknown error';
}
